import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import qs from 'qs';

import { filterEmptyParams, restUrl } from '@/services/utils';

import { CommunityOption, memberCommunities, SearchedOrganization } from './searchedOrganization';

interface OrganizationSearchParams {
    keyword?: string;
    communityId?: number;
}

export const useMemberCommunities = (enabled: boolean) =>
    useQuery({
        queryKey: ['organizations', 'communities'],
        enabled,
        queryFn: async () => {
            const response = await axios.get<CommunityOption[]>(restUrl('communities'));
            return memberCommunities(response.data ?? []);
        },
    });

export const useOrganizationSearch = (params: OrganizationSearchParams, enabled: boolean) =>
    useQuery({
        queryKey: ['organizations', 'search', params.keyword ?? '', params.communityId ?? null],
        enabled,
        queryFn: async () => {
            const response = await axios.get<SearchedOrganization[]>(restUrl('organizations'), {
                params: {
                    keyword: params.keyword,
                    communityId: params.communityId,
                },
                paramsSerializer: (query) => qs.stringify(filterEmptyParams(query)),
            });
            return response.data ?? [];
        },
    });

export const useInviteOrganization = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (invitation: { organizationId: number; invitationType: 'CONTACT_REQUEST'; text?: string }) =>
            axios.post(restUrl('contacts'), invitation),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['organizations', 'search'] }),
    });
};
